import React from 'react';
import type {TextProps} from '@tempo/core';
import {Text} from '@tempo/core';
import type {TdProps} from '../core/Td';
import Td from '../core/Td';

type TextCellProps = {
	value: string | number;
	variant?: TextProps['variant'];
} & TdProps;

const TextCell = ({
	value,
	color,
	noOfLines,
	variant,
	...rest
}: TextCellProps) => {
	return (
		<Td {...rest}>
			<Text
				noOfLines={noOfLines || 2}
				whiteSpace={'pre-wrap'}
				color={color || 'text.neutral.primary.default'}
				variant={variant}
			>
				{value}
			</Text>
		</Td>
	);
};

export default TextCell;
